/**
 * 基础路由
 * @type { *[] }
 * meta:{
 *      title:'首页' ,  //type:String   页面标题
 *      keepAlive：false, // type:Boolean 页面是否缓存 回退时 不会刷新页面
 *      needLogin:false , // type:Boolean  是否需要登录
 *      forbiddenAnimation:false,//type:Boolean 是否加转场动画
 * }
 */
export const constantRouterMap = [
  {
    path: "/",
    component: () => import("@/views/index/wap"),
    beforeEnter: (to, from, next) => {
      const origin = window.location.origin;
      if (origin.indexOf("blueskyicp.com") >= 0 ) {
        next({ path: "/ganliao" });
      } else {
        const flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        if (flag) {
          next({ path: "/wap" });
        } else {
          next({ path: "/pc" });
        }
      }
    }
  },
  {
    path: "/broker",
    component: () => import("@/views/layouts/index"),
    redirect: "/broker/home",
    meta: {
      title: "红娘中心",
      keepAlive: false,
      needLogin: false
    },
    children: [
      {
        path: "home",
        name: "Home",
        component: () => import("@/views/broker/home/index"),
        meta: { title: "红娘中心", keepAlive: true }
      },
      {
        path: "gradeIntro",
        name: "Gradeintro",
        component: () => import("@/views/broker/home/gradeIntro"),
        meta: { title: "红娘等级说明", keepAlive: false }
      },
      {
        path: "room",
        name: "Room",
        component: () => import("@/views/broker/room/room"),
        meta: { title: "我的三人房", keepAlive: true }
      },
      {
        path: "roomdetail",
        name: "Roomdetail",
        component: () => import("@/views/broker/room/roomdetail"),
        meta: { title: "我的三人房", keepAlive: true }
      },
      {
        path: "rate",
        name: "Rate",
        component: () => import("@/views/broker/rate/rate"),
        meta: { title: "开播评价", keepAlive: true }
      },
      {
        path: "slaves",
        name: "Slaves",
        component: () => import("@/views/broker/slaves/slaves"),
        meta: { title: "我的徒弟", keepAlive: true }
      },
      {
        path: "preslaves",
        name: "Preslaves",
        component: () => import("@/views/broker/slaves/preslaves"),
        meta: { title: "备选徒弟", keepAlive: true }
      },
      {
        path: "slavesintro",
        name: "Slavesintro",
        component: () => import("@/views/broker/slaves/slavesIntro"),
        meta: { title: "如何收徒", keepAlive: false }
      },
      {
        path: "invite",
        name: "Invite",
        component: () => import("@/views/broker/invite/index"),
        meta: { title: "我的邀请", keepAlive: true }
      },
      {
        path: "invitecode",
        name: "Invitecode",
        component: () => import("@/views/broker/invite/invitecode"),
        meta: { title: "我的邀请码", keepAlive: true }
      },
      {
        path: "brokerrule",
        name: "Brokerrule",
        component: () => import("@/views/broker/home/brokerrule"),
        meta: { title: "红娘规范", keepAlive: false }
      },
      {
        path: "training",
        name: "Training",
        component: () => import("@/views/broker/training"),
        meta: { title: "红娘教程", keepAlive: true }
      },
      {
        path: "subsidy",
        name: "Subsidy",
        component: () => import("@/views/broker/subsidy"),
        meta: { title: "周奖励", keepAlive: true }
      }
    ]
  },
  {
    path: "/paytrainingfee",
    name: "Paytrainingfee",
    component: () => import("@/views/wechatbroker/paytrainingfee"),
    meta: { title: "培训费缴纳", keepAlive: true, needLogin: false },
    beforeEnter: (to, from, next) => {
      const code = to.query.code;
      // const local = window.location.href
      if (code == null || code === "") {
        // window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa5f1f4c5fd424838&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_base&state=state#wechat_redirect'
        next();
      } else {
        next();
      }
    }
  },
  {
    path: "/invitationBinding",
    name: "InvitationBinding",
    component: () => import("@/views/invitationBinding/index"),
    meta: { title: "给缘", keepAlive: true, needLogin: false }
  },
  {
    path: "/bindingCompleted",
    name: "BindingCompleted",
    component: () => import("@/views/invitationBinding/bindingCompleted"),
    meta: { title: "给缘", keepAlive: true, needLogin: false }
  },
  {
    path: "/wxlogin",
    name: "Wxlgoin",
    component: () => import("@/views/wechatbroker/login"),
    meta: { title: "给缘", keepAlive: true, needLogin: false }
  },
  {
    path: "/bindmaster",
    name: "Bindmaster",
    component: () => import("@/views/wechatbroker/bindmaster"),
    meta: { title: "拜师", keepAlive: true, needLogin: false }
  },
  {
    path: "/shifu",
    name: "Shifu",
    component: () => import("@/views/broker/myShifu"),
    meta: { title: "我的师傅", keepAlive: true, needLogin: false }
  },
  // 给缘官网
  {
    path: "/pc",
    name: "Pc",
    component: () => import("@/views/index/pc"),
    meta: { title: "给缘", keepAlive: true, needLogin: false }
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("@/views/index/pcxj"),
    meta: { title: "联系我们", keepAlive: true, needLogin: false }
  },
  // 大转盘规则
  {
    path: "/turntableRule",
    name: "TurntableRule",
    component: () => import("@/views/index/turntableRule"),
    meta: { title: "感聊", keepAlive: true, needLogin: false }
  },
  {
    path: "/support",
    name: "Support",
    component: () => import("@/views/index/support"),
    meta: { title: "给缘", keepAlive: true, needLogin: false }
  },
  // 封禁列表
  {
    path: "/banedList",
    name: "BanedList",
    component: () => import("@/views/index/banedList"),
    meta: { title: "违规名单", keepAlive: true, needLogin: false }
  },
  {
    path: "/wap",
    name: "Wap",
    component: () => import("@/views/index/wap"),
    meta: { title: "给缘", keepAlive: true, needLogin: false }
  },
  // 开展网络谣言
  {
    path: "/ld1",
    name: "Ld1",
    component: () => import("@/views/index/ld1"),
    meta: { title: "给缘", keepAlive: true, needLogin: false }
  },
  // 平台严禁条例
  {
    path: "/ld2",
    name: "Ld2",
    component: () => import("@/views/index/ld2"),
    meta: { title: "给缘", keepAlive: true, needLogin: false }
  },
  // 平台行为规范
  {
    path: "/ld3",
    name: "Ld3",
    component: () => import("@/views/index/ld3"),
    meta: { title: "给缘", keepAlive: true, needLogin: false }
  },
  {
    path: "/wapActivity",
    name: "WapActivity",
    component: () => import("@/views/index/wapActivity"),
    meta: { title: "给缘", keepAlive: true, needLogin: false }
  },
  {
    path: "/landingpage",
    name: "landingpage",
    component: () => import("@/views/index/landingpage"),
    meta: { title: "给缘", keepAlive: true, needLogin: false }
  },
  {
    path: "/demo",
    name: "Demo",
    component: () => import("@/views/index/demo"),
    meta: { title: "给缘", keepAlive: true, needLogin: false }
  },
  {
    path: "/share",
    name: "Share",
    component: () => import("@/views/index/wxshare"),
    meta: { title: "给缘", keepAlive: true, needLogin: false }
  },
  {
    path: "/aliface",
    name: "Aliface",
    component: () => import("@/views/index/aliface"),
    meta: { title: "实人认证", keepAlive: true, needLogin: false }
  },
  {
    path: "/wxrecharge",
    name: "Wxrecharge",
    component: () => import("@/views/wechatbroker/recharge"),
    meta: { title: "充值心意", keepAlive: true, needLogin: false }
  },
  {
    path: "/withdrawal",
    name: "Withdrawal",
    component: () => import("@/views/withdrawal/gongmao"),
    meta: { title: "提现", keepAlive: true, needLogin: false }
  },
  // 提现记录
  {
    path: "/withdrawHistory",
    name: "withdrawHistory",
    component: () => import("@/views/withdrawal/history"),
    meta: { title: "提现记录", keepAlive: true, needLogin: false }
  },
  {
    path: "/brokersubsidy",
    name: "Brokersubsidy",
    component: () => import("@/views/index/brokersubsidy"),
    meta: { title: "补贴汇总", keepAlive: true, needLogin: false }
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () => import("@/views/index/privacy"),
    meta: { title: "隐私协议", keepAlive: true, needLogin: false }
  },
  {
    path: "/greenConvention",
    name: "GreenConvention",
    component: () => import("@/views/index/greenConvention"),
    meta: { title: "绿色公约", keepAlive: true, needLogin: false }
  },
  {
    path: "/privacyIos",
    name: "PrivacyIos",
    component: () => import("@/views/index/privacyIos"),
    meta: { title: "隐私协议", keepAlive: true, needLogin: false }
  },
  {
    path: "/recharge",
    name: "Recharge",
    component: () => import("@/views/index/recharge"),
    meta: { title: "充值协议", keepAlive: true, needLogin: false }
  },
  {
    path: "/video",
    name: "Video",
    component: () => import("@/views/index/video"),
    meta: { title: "主播服务协议", keepAlive: true, needLogin: false }
  },
  {
    path: "/sdkprivacy",
    name: "Sdkprivacy",
    component: () => import("@/views/index/sdkprivacy"),
    meta: { title: "SDK技术说明文档", keepAlive: true, needLogin: false }
  },
  {
    path: "/sdkprivacyIos",
    name: "SdkprivacyIos",
    component: () => import("@/views/index/sdkprivacyIos"),
    meta: { title: "SDK技术说明文档", keepAlive: true, needLogin: false }
  },
  {
    path: "/accessinfo",
    name: "Accessinfo",
    component: () => import("@/views/index/accessinfo"),
    meta: { title: "权限说明文档", keepAlive: true, needLogin: false }
  },
  {
    path: "/usersecurity",
    name: "Privacy",
    component: () => import("@/views/index/usersecurity"),
    meta: { title: "安全中心", keepAlive: true, needLogin: false }
  },
  {
    path: "/rule",
    name: "Rule",
    component: () => import("@/views/index/rule"),
    meta: { title: "平台规则", keepAlive: true, needLogin: false }
  },
  {
    path: "/agreement",
    name: "Agreement",
    component: () => import("@/views/index/agreement"),
    meta: { title: "用户协议", keepAlive: true, needLogin: false }
  },
  {
    path: "/agreementIos",
    name: "AgreementIos",
    component: () => import("@/views/index/agreementIos"),
    meta: { title: "用户协议", keepAlive: true, needLogin: false }
  },
  {
    path: "/agreementxj",
    name: "Agreementxj",
    component: () => import("@/views/index/agreement_xj"),
    meta: { title: "用户协议", keepAlive: true, needLogin: false }
  },
  {
    path: "/privacyxj",
    name: "Privacyxj",
    component: () => import("@/views/index/privacy_xj"),
    meta: { title: "隐私协议", keepAlive: true, needLogin: false }
  },
  {
    path: "/contactxj",
    name: "Contactxj",
    component: () => import("@/views/index/contactus_xj"),
    meta: { title: "联系我们", keepAlive: true, needLogin: false }
  },
  {
    path: "/recruit",
    name: "Recruit",
    component: () => import("@/views/index/recruit"),
    meta: { title: "招募红娘", keepAlive: true, needLogin: false }
  },
  {
    path: "/recruit2",
    name: "Recruit2",
    component: () => import("@/views/index/recruit2"),
    meta: { title: "招募红娘", keepAlive: true, needLogin: false }
  },
  {
    path: "/recruitNojwt",
    name: "RecruitNojwt",
    component: () => import("@/views/index/recruitNojwt"),
    meta: { title: "招募红娘", keepAlive: true, needLogin: false }
  },
  {
    path: "/securitycenter",
    name: "securitycenter",
    component: () => import("@/views/index/securitycenter"),
    meta: { title: "安全中心", keepAlive: true, needLogin: false }
  },
  // 活动业务页面
  {
    path: "/actflow",
    name: "Actflow",
    component: () => import("@/views/broker/act/flowBanner"),
    meta: { title: "给缘", keepAlive: true, needLogin: false }
  },
  {
    path: "*",
    name: "NotFound",
    component: () => import("@/views/public/404"),
    meta: { title: "打开失败-404", keepAlive: true, needLogin: false }
  },
  {
    path: "/activity",
    component: () => import("@/views/layouts/index"),
    meta: {
      title: "活动",
      keepAlive: false,
      needLogin: false
    },
    children: [
      {
        path: "rank1101",
        name: "Rank1101",
        component: () => import("@/views/activity/rank1101/index"),
        meta: { title: "排行榜", keepAlive: true }
      },
      {
        path: "rankLast1101",
        name: "RankLast1101",
        component: () => import("@/views/activity/rank1101/rankLast1101"),
        meta: { title: "排行榜", keepAlive: true }
      },
      {
        path: "rankMyInfo1101",
        name: "RankMyInfo1101",
        component: () => import("@/views/activity/rank1101/rankMyInfo1101"),
        meta: { title: "排行榜", keepAlive: true }
      },
      {
        path: "purifyNetwork",
        name: "PurifyNetwork",
        component: () => import("@/views/activity/purifyNetwork/index"),
        meta: { title: "净网行动", keepAlive: true }
      },
      {
        path: "heatdegree",
        name: "Heatdegree",
        component: () => import("@/views/activity/heatdegree/index"),
        meta: { title: "热门卡助力直播间", keepAlive: true }
      },
      {
        path: "fraud",
        name: "fraud",
        component: () => import("@/views/activity/fraud/index"),
        meta: { title: "提高用户安全意识", keepAlive: true }
      },
      {
        path: "doubleEgg",
        name: "doubleEgg",
        component: () => import("@/views/activity/doubleEgg/index"),
        meta: { title: "签到集星光", keepAlive: true }
      },
      {
        path: "newYearRank",
        name: "newYearRank",
        component: () => import("@/views/activity/newYearRank/index"),
        meta: { title: "新春集福气", keepAlive: true }
      },
      {
        path: "previousRank",
        name: "previousRank",
        component: () => import("@/views/activity/newYearRank/previousRank"),
        meta: { title: "往期榜单", keepAlive: true }
      },
      {
        path: "newYearBenefit",
        name: "newYearBenefit",
        component: () => import("@/views/activity/newYearBenefit/index"),
        meta: { title: "新春福利大派送", keepAlive: true }
      }
    ]
  },
  {
    path: "/landing",
    name: "landing",
    component: () => import("@/views/landingPage/landing"),
    meta: { title: "给缘", keepAlive: true, needLogin: false }
  },
  // {
  //   path: "/h5recharge",
  //   name: "h5recharge",
  //   component: () => import("@/views/h5recharge/recharge"),
  //   meta: { title: "给缘心意充值", keepAlive: true, needLogin: false }
  // },
  // 公众号相关
  {
    path: "/officialAccount",
    name: "officialAccount",
    component: () => import("@/views/officialAccount/index"),
    meta: { title: "公众号", keepAlive: true, needLogin: false },
    children:[
      {
        path: "recharge",
        name: "recharge",
        component:()=>import ("@/views/officialAccount/recharge"),
        meta:{
          meta: { title: "心意充值", keepAlive: true, needLogin: false },
        },
        beforeEnter: (to, from, next) => {
          const code = to.query.code;
          const local = window.location.href;
          console.log('https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa5f1f4c5fd424838&redirect_uri='+ encodeURIComponent(local)+'&response_type=code&scope=snsapi_base&state=state#wechat_redirect');
          if (code == null || code === "") {
            window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa5f1f4c5fd424838&redirect_uri=' + encodeURIComponent(local)+'&response_type=code&scope=snsapi_base&state=state#wechat_redirect'
            next();
          } else {
            next();
          }
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/router.config.js